import { z } from 'zod';

export const RequiredErrorMessage = Object.freeze({ message: 'This field is required.' });

export const zNonEmptyString = z.string().min(1, RequiredErrorMessage);
